import type { SceneDoc } from '@spirits/shared';

interface Props {
  scene?: Pick<SceneDoc, 'name' | 'blurb' | 'description'> | null;
  className?: string;
}

// The scene's "setting" intro: an eyebrow label, the scene name + blurb, and the
// atmosphere/description card. Shown in the desktop guidance panel and on top of
// the soul list on mobile.
export function SceneSetting({ scene, className = '' }: Props) {
  if (!scene?.description) return null;
  return (
    <div className={`space-y-4 ${className}`}>
      <div className="space-y-1.5">
        <p className="text-[10px] uppercase tracking-[0.25em] text-amber-400/60">the setting</p>
        <h2 className="text-2xl text-slate-200 tracking-wide">{scene.name ?? 'A place unseen'}</h2>
        {scene.blurb && <p className="text-sm leading-snug text-slate-400">{scene.blurb}</p>}
      </div>
      <div className="rounded-lg border border-slate-800 bg-slate-900/40 p-4">
        <p className="text-left text-sm leading-relaxed text-slate-400 whitespace-pre-line">
          {scene.description}
        </p>
      </div>
    </div>
  );
}
